import { useTranslation } from "react-i18next";
import { getProfileTabHref, getProfileTabs } from "./profileTabs.config";

const ProfileTabs = ({
  section,
  athlete,
  query,
  clientConfigurationPending,
}) => {
  const { t } = useTranslation("athlete-portal");
  const organizationCoach = query.organizationCoach || undefined;

  return (
    <nav role="tablist">
      {getProfileTabs(athlete).map((tab) => (
        <a
          key={tab.section}
          aria-current={section === tab.section ? true : undefined}
          href={getProfileTabHref(tab.section, athlete, organizationCoach)}
        >
          {tab.section === "client-configuration" ? (
            <>
              <span
                style={{
                  display: "inline-block",
                  backgroundColor: "var(--danger)",
                  color: "#fff",
                  borderRadius: "var(--border-radius-md)",
                  padding: "2px 8px",
                  fontSize: "0.7em",
                  fontWeight: 700,
                  letterSpacing: "0.02em",
                  verticalAlign: "middle",
                }}
              >
                {t("profile.clientConfigurationNewBadge")}
              </span>
              {t(tab.labelKey)}
              {clientConfigurationPending && (
                <span
                  role="img"
                  aria-label={t("profile.clientConfigurationPending")}
                  title={t("profile.clientConfigurationPending")}
                  style={{
                    display: "inline-flex",
                    alignItems: "center",
                    justifyContent: "center",
                    width: "1.5em",
                    height: "1.5em",
                    borderRadius: "50%",
                    backgroundColor: "var(--warning-opacity)",
                    color: "var(--warning)",
                    fontSize: "0.75em",
                    fontWeight: 700,
                    verticalAlign: "middle",
                  }}
                >
                  !
                </span>
              )}
            </>
          ) : (
            t(tab.labelKey)
          )}
        </a>
      ))}
    </nav>
  );
};

export default ProfileTabs;
